var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoices" },
    [
      _c(
        "div",
        { staticClass: "main-wrapper" },
        [
          _c("layout-header"),
          _vm._v(" "),
          _c("layout-sidebar"),
          _vm._v(" "),
          _c("div", { staticClass: "page-wrapper" }, [
            _c("div", { staticClass: "content container-fluid" }, [
              _c("div", { staticClass: "page-header" }, [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("h3", { staticClass: "page-title" }, [_vm._v("Logs")]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "breadcrumb" }, [
                      _c(
                        "li",
                        { staticClass: "breadcrumb-item" },
                        [
                          _c("router-link", { attrs: { to: "/index" } }, [
                            _vm._v("Dashboard")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("li", { staticClass: "breadcrumb-item active" }, [
                        _vm._v("Logs")
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              !_vm.selectedTable.length
                ? _c("div", { staticClass: "row filter-row" }, [
                    _c("div", { staticClass: "col-sm-6 col-md-3" }, [
                      _c("div", { staticClass: "form-group form-focus" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.serverParams.columnFilters.start_date,
                              expression:
                                "serverParams.columnFilters.start_date"
                            }
                          ],
                          staticClass: "form-control floating",
                          attrs: { type: "date" },
                          domProps: {
                            value: _vm.serverParams.columnFilters.start_date
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.serverParams.columnFilters,
                                "start_date",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { staticClass: "focus-label sr-only" }, [
                          _vm._v("From")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-6 col-md-3" }, [
                      _c("div", { staticClass: "form-group form-focus" }, [
                        _c("div", { staticClass: "input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.serverParams.columnFilters.end_date,
                                expression:
                                  "serverParams.columnFilters.end_date"
                              }
                            ],
                            staticClass: "form-control floating",
                            attrs: { type: "date" },
                            domProps: {
                              value: _vm.serverParams.columnFilters.end_date
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.serverParams.columnFilters,
                                  "end_date",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group-append" }, [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  title: "Show search options",
                                  href: "#",
                                  "data-toggle": "modal",
                                  "data-target": "#search_form"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showSearchForm()
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-list" }),
                                _vm._v(" "),
                                _vm.formParamSt.more_search == true
                                  ? _c("i", { staticClass: "fa fa-circle" })
                                  : _vm._e()
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "focus-label sr-only" }, [
                          _vm._v("To")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-6 col-md-3" }, [
                      _c("div", { staticClass: "form-group form-focus" }, [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-success btn-block",
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.searchData($event)
                              }
                            }
                          },
                          [_vm._v("Search")]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _vm.loading
                    ? [
                        _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [_c("skeleton", { attrs: { count: 1 } })],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rows.length
                    ? _vm._l(_vm.rowsSummary, function(row, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-md-6 col-sm-6 col-lg-6 col-xl-3"
                          },
                          [
                            _c("div", { staticClass: "card dash-widget" }, [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "span",
                                  { staticClass: "dash-widget-icon" },
                                  [
                                    row.label == "total_like"
                                      ? _c("i", {
                                          staticClass: "fa fa-thumbs-up"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.label == "total_play"
                                      ? _c("i", { staticClass: "fa fa-play" })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.label == "total_comment"
                                      ? _c("i", {
                                          staticClass: "fa fa-comment"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.label == "total_impressions"
                                      ? _c("i", { staticClass: "fa fa-eye" })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.label == "total_reach"
                                      ? _c("i", {
                                          staticClass: "fa fa-podcast"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.label == "total_interactions"
                                      ? _c("i", { staticClass: "fa fa-users" })
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "dash-widget-info" }, [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(_vm._f("angkaKMB")(row.total))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  row.label == "total_like"
                                    ? _c("span", [_vm._v("Like")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.label == "total_play"
                                    ? _c("span", [_vm._v("Play")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.label == "total_comment"
                                    ? _c("span", [_vm._v("Comment")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.label == "total_impressions"
                                    ? _c("span", [_vm._v("Impression")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.label == "total_reach"
                                    ? _c("span", [_vm._v("Reach")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.label == "total_interactions"
                                    ? _c("span", [_vm._v("Interactions")])
                                    : _vm._e()
                                ])
                              ])
                            ])
                          ]
                        )
                      })
                    : _vm.rows.length < 1 && !_vm.loading
                    ? [
                        _c("div", { staticClass: "col-md-12 text-center" }, [
                          _vm._v("-empty-")
                        ])
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "div",
                    { staticClass: "row align-items-start" },
                    [
                      _vm.loading
                        ? [
                            _c(
                              "div",
                              { staticClass: "col-md-12" },
                              [_c("skeleton", { attrs: { count: 1 } })],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rows.length
                        ? _vm._l(_vm.rows, function(row, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "col-md-6 col-xl-4 pb-4"
                              },
                              [
                                _c("div", { staticClass: "of-card" }, [
                                  _c("div", { staticClass: "of-card-top" }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "of-card-header" }, [
                                    _c("div", { staticClass: "of-card-h-1" }, [
                                      _c(
                                        "div",
                                        { staticClass: "of-card-h-2" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "of-card-h-3" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "of-card-h-4" },
                                                [
                                                  _c("img", {
                                                    staticClass: "of-card-h-5",
                                                    attrs: {
                                                      src: require("@/assets/user.jpg"),
                                                      alt: ""
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "of-card-h-6" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  ref: "account-" + row.id,
                                                  refInFor: true,
                                                  staticClass: "of-card-h-7"
                                                },
                                                [
                                                  _c("Skeleton", {
                                                    attrs: { count: 1 }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "of-card-h-8" },
                                                [
                                                  _vm._v(
                                                    "\n                              " +
                                                      _vm._s(
                                                        _vm.formatLocalDate(
                                                          row.update_datetime
                                                        )
                                                      ) +
                                                      "\n                            "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "of-card-body" }, [
                                    _c(
                                      "div",
                                      { staticClass: "of-card-body-a" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "of-card-body-cap" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "of-card-body-cap-1"
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "of-card-body-cap-2",
                                                    attrs: {
                                                      title: row.caption
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                              " +
                                                        _vm._s(row.caption) +
                                                        "\n                            "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "of-card-body-img" },
                                          [
                                            JSON.parse(row.assets_url).length >
                                            0
                                              ? [
                                                  JSON.parse(
                                                    row.assets_url
                                                  )[0].includes(".jpg") ||
                                                  JSON.parse(
                                                    row.assets_url
                                                  )[0].includes(".jpeg")
                                                    ? _c("img", {
                                                        staticClass:
                                                          "of-card-body-img-p",
                                                        staticStyle: {
                                                          cursor: "zoom-in"
                                                        },
                                                        attrs: {
                                                          title: "Lihat Gambar",
                                                          src: JSON.parse(
                                                            row.assets_url
                                                          )[0],
                                                          alt: row.caption
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.openImage(
                                                              JSON.parse(
                                                                row.assets_url
                                                              )[0]
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : JSON.parse(
                                                        row.assets_url
                                                      )[0].includes(".mp4")
                                                    ? _c(
                                                        "video",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                            height: "100%",
                                                            overflow: "hidden"
                                                          },
                                                          attrs: {
                                                            controls: ""
                                                          }
                                                        },
                                                        [
                                                          _c("source", {
                                                            attrs: {
                                                              src: JSON.parse(
                                                                row.assets_url
                                                              )[0],
                                                              type: "video/mp4"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _c("img", {
                                                        staticClass:
                                                          "of-card-body-img-p",
                                                        attrs: {
                                                          src: require("@/assets/placeholder.jpg"),
                                                          alt: ""
                                                        }
                                                      })
                                                ]
                                              : [
                                                  _c("img", {
                                                    staticClass:
                                                      "of-card-body-img-p",
                                                    attrs: {
                                                      src: require("@/assets/placeholder.jpg"),
                                                      alt: ""
                                                    }
                                                  })
                                                ]
                                          ],
                                          2
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "of-card-body-b"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "of-card-body-c" },
                                      [
                                        _c(
                                          "table",
                                          { staticClass: "of-card-table" },
                                          [
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-l"
                                                  },
                                                  [_vm._v("Brand")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-r"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        ref: "brand-" + row.id,
                                                        refInFor: true,
                                                        staticStyle: {
                                                          width: "150px"
                                                        }
                                                      },
                                                      [
                                                        _c("Skeleton", {
                                                          attrs: { count: 1 }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-l"
                                                  },
                                                  [_vm._v("Media Type")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-r"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "badge badge-primary"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(row.media_type)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-l"
                                                  },
                                                  [_vm._v("Like")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-r"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(row.total_like) +
                                                        "\n                              "
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-l"
                                                  },
                                                  [_vm._v("Play")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-r"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(row.total_play) +
                                                        "\n                              "
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-l"
                                                  },
                                                  [_vm._v("Comments")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-r"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(
                                                          row.total_comment
                                                        ) +
                                                        "\n                              "
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-l"
                                                  },
                                                  [_vm._v("Impressions")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-r"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(
                                                          row.total_impressions
                                                        ) +
                                                        "\n                              "
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-l"
                                                  },
                                                  [_vm._v("Reach")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-r"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(
                                                          row.total_reach
                                                        ) +
                                                        "\n                              "
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-l"
                                                  },
                                                  [_vm._v("Interactions")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "of-card-td-r"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(
                                                          row.total_interactions
                                                        ) +
                                                        "\n                              "
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c(
                                                "tr",
                                                {
                                                  staticStyle: {
                                                    border: "none"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "of-card-td-l"
                                                    },
                                                    [_vm._v("Status")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "of-card-td-r"
                                                    },
                                                    [
                                                      row.post_status == 2
                                                        ? _c("div", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "badge badge-success"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Published"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href:
                                                                    "https://www.instagram.com/p/" +
                                                                    row.instagram_media_code,
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "la la-external-link",
                                                                  staticStyle: {
                                                                    "font-size":
                                                                      "16px"
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ])
                                                        : row.post_status == 1
                                                        ? _c("div", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "badge badge-info"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Connecting..."
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "badge badge-danger"
                                                            },
                                                            [
                                                              _c(
                                                                "VueCustomTooltip",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      row.post_reason,
                                                                    multiline:
                                                                      "",
                                                                    position:
                                                                      "is-left"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Failed"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ]
                            )
                          })
                        : _vm.rows.length < 1 && !_vm.loading
                        ? [
                            _c(
                              "div",
                              { staticClass: "col-md-12 text-center" },
                              [_vm._v("-empty-")]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-12 col-md-6" }, [
                  _c("span", { staticClass: "footer__row-count__label" }, [
                    _vm._v("Displaying")
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.serverParams.perPage,
                          expression: "serverParams.perPage"
                        }
                      ],
                      staticClass: "select-to-paginasi",
                      staticStyle: { width: "100px" },
                      attrs: { autocomplete: "off", name: "perPageSelect" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.serverParams,
                              "perPage",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function($event) {
                            return _vm.onPerPageChange(_vm.serverParams.perPage)
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "10" } }, [
                        _vm._v("10 / page")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "20" } }, [
                        _vm._v("20 / page")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "30" } }, [
                        _vm._v("30 / page")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "40" } }, [
                        _vm._v("40 / page")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "50" } }, [
                        _vm._v("50 / page")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "footer__row-count__label" }, [
                    _vm._v("of " + _vm._s(_vm.totalRecords) + " total records")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-12 col-md-6 text-right" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn",
                      class: { disabled: parseInt(_vm.currentPage) - 1 <= 0 },
                      attrs: { href: "javascript:void(0)", tabindex: "0" },
                      on: {
                        click: function($event) {
                          _vm.onPrevChange(parseInt(_vm.currentPage))
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "chevron left" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Prev")])
                    ]
                  ),
                  _vm._v("\n            page\n            "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentPage,
                        expression: "currentPage"
                      }
                    ],
                    staticStyle: { width: "100px" },
                    attrs: { min: "1", type: "number" },
                    domProps: { value: _vm.currentPage },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        _vm.onPageChange(parseInt(_vm.currentPage))
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.currentPage = $event.target.value
                      }
                    }
                  }),
                  _vm._v(
                    "\n            of " +
                      _vm._s(
                        Math.ceil(_vm.totalRecords / _vm.serverParams.perPage)
                      ) +
                      "\n            "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "footer__navigation__page-btn",
                      class:
                        "btn " +
                        {
                          disabled:
                            parseInt(_vm.currentPage) + 1 >
                            Math.ceil(
                              _vm.totalRecords / _vm.serverParams.perPage
                            )
                        },
                      attrs: { href: "javascript:void(0)", tabindex: "0" },
                      on: {
                        click: function($event) {
                          _vm.onNextChange(parseInt(_vm.currentPage))
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v("Next")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "chevron right" })
                    ]
                  )
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("form-data", { attrs: { searchData: _vm.searchDataMore } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32fd9250", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32fd9250","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/instagram/instagramLogsOfficial/list.vue
// module id = null
// module chunks = 